const users = {
  users: 'Admin Users',
  addUsers: 'Add Admin  Users',
  editUsers: 'Edit Admin Users',
  loginLog: 'Login Logs',
  permission: 'Permission',
};
export default users;
